import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { type SkillOnboardingImageName } from '~/constants/skillOnboardingImages';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

export type PendingSkillRun = {
  skillSlashCommand: string;
  imageName: SkillOnboardingImageName;
  canvasId: string;
};

type State = {
  pendingSkillRun: PendingSkillRun | null;
  setPendingSkillRun: (run: PendingSkillRun) => void;
  clearPendingSkillRun: () => void;
};

export const usePendingSkillRunStore = create<State>()(
  persist(
    (set) => ({
      pendingSkillRun: null,
      setPendingSkillRun: (run) => set({ pendingSkillRun: run }),
      clearPendingSkillRun: () => set({ pendingSkillRun: null }),
    }),
    {
      name: ZustandStorageKeys.SkillOnboardingPendingRun,
      partialize: (state) => ({ pendingSkillRun: state.pendingSkillRun }),
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
